import { render, staticRenderFns } from "./AlbumTextZone.vue?vue&type=template&id=5ef63534&scoped=true&"
import script from "./AlbumTextZone.vue?vue&type=script&lang=js&"
export * from "./AlbumTextZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumTextZone.vue?vue&type=style&index=0&id=5ef63534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef63534",
  null
  
)

export default component.exports